// import './func/buffer-dump'
import debounce from './func/debounce';
import caculate from './func/caculate';
import softSolutionProbe from './func/softSolution-probe';
export { debounce, caculate, softSolutionProbe };